module.exports = __webpack_public_path__ + "media/Video 5.80bcac90.mp4";